import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PageService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}/api`);
  }

  /* get list of pages by role */
  listPageActor(id: any) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForCompany?interface=${id}&role_id=${id}`
    );
  }
  listPageActorclient() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForCompany?interface=9&role_id=9`
    );
  }
  /* change Sub Page State */
  changeSubPageState(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/CompanyPageActeur/addRemoveSubPageToActeurEsn`,
      data
    );
  }
  /* get list of pages by role intervenant*/
  listPageActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=10`
    );
  }
  /* change Sub Page State */
  changeSubPageStateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
}
